import { UserType } from "../types";
import axiosClient from "./axiosClient";

export const userApi = {

  fetchUser: () => {
    return axiosClient.post(`/fetchUser`);
  },

  updateUser: (updatedFields: Partial<UserType>) => {
    return axiosClient.put(`/updateUser`, {updatedFields});
  },

  logUserEvent: (event: string, cardKey: number | null = null) => {
    //const userKey = getUserInfo()?.userKey;
    return axiosClient.post(`/logUserEvent`, {event, cardKey});
  },

  editUser: (targetUserKey: number, role: string, status: number, userEditToken: string) => {
    return axiosClient.put(`/editUser`, {targetUserKey, role, status, userEditToken});
  },

  activateUser: (targetUserKey: number, active: boolean) => {
    return axiosClient.put(`/activateUser`, {targetUserKey, active});
  },

  addUser: (targetUserKey: number, firstName: string, lastName: string) => {
    return axiosClient.post(`/addUser`, {targetUserKey, firstName, lastName});
  },
};
